import React, { useState } from "react";
import { useAddTeacher } from "../../Hooks/index";
import DropFile from "../../../../../Common/Components/DropFile";
function AddTeacher() {
  const [form, setForm] = useState();

  const { loading, sendForm } = useAddTeacher();
  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between m-3">
            <label>نام مدرس:</label>
            <input
              className="form-control col-8"
              onChange={e => {
                setForm({ ...form, name: e.target.value });
              }}
            />
          </div>
          <div className="d-flex justify-content-between m-3">
            <label>سابقه فعالیت:</label>
            <input
              className="form-control col-8"
              onChange={e => {
                setForm({ ...form, activity: e.target.value });
              }}
            />
          </div>
          <div className="d-flex justify-content-between m-3">
            <label>مدارک:</label>
            <input
              className="form-control col-8"
              onChange={e => {
                setForm({ ...form, proof: e.target.value });
              }}
            />
          </div>
          <div className="d-flex justify-content-between m-3">
            <label>افتخارات:</label>
            <input
              className="form-control col-8"
              onChange={e => {
                setForm({ ...form, cv: e.target.value });
              }}
            />
          </div>
          <div className="d-flex justify-content-between m-3">
            <label>جزییات:</label>
            <input
              className="form-control col-8"
              onChange={e => {
                setForm({ ...form, destails: e.target.value });
              }}
            />
          </div>
          <div className="d-flex justify-content-between m-3">
            <label>جزییات:</label>
            <DropFile
              accept={"image/png, image/jpeg"}
              set={e => {
                setForm({ ...form, image: e });
              }}
            />
          </div>
          {/*     accept={element.accept}
                      set={(e) => {
                        setstate({ ...state, image: e });
                      }} */}
          <div className="text-center mt-5 ">
            <button
              className="btn btn-success"
              onClick={() => {
                sendForm({
                  ...form,
                  action: "add",
                });
              }}
            >
              {loading ? "در حال پردازش" : "ثبت مدرس"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddTeacher;
